var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sb-loading",class:`sb-color-${_vm.variant}`,style:({width: `${_vm.size}px`})},_vm._l((30),function(n){return _c('div',{key:n})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }